import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import '../styles/EmailVerificationPage.css'; 

const EmailVerificationPage = () => {
  const [verificationCode, setVerificationCode] = useState('');
  const [verificationError, setVerificationError] = useState('');
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [resendCountdown, setResendCountdown] = useState(60);
  const [showCodeSentMessage, setShowCodeSentMessage] = useState(false);
  const navigate = useNavigate();
  const { user_id } = useParams();

  // Countdown logic to re-enable the resend button and hide the message once the timer ends.
  useEffect(() => {
    let timer;
    if (isResendDisabled) {
      timer = setInterval(() => {
        setResendCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setIsResendDisabled(false);
            setShowCodeSentMessage(false);
            return 60; // Reset timer for future use.
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [isResendDisabled]);

  const handleVerify = async (event) => {
    event.preventDefault();
    try {
      const url = `https://api.bestday2marry.com/check_passcode/?user_id=${user_id}&passcode=${verificationCode}`;    
      const response = await fetch(url);
      const data = await response.json();
      if (data['status'] === 'success') {
        const accountType = localStorage.getItem('accountType');
        if (accountType === 'business') {
          navigate(`/business_plan/${user_id}`);
        } else if (accountType === 'couple') {
          navigate(`/matching_flow/${user_id}`);
        } else {
          navigate(`/dashboard/${user_id}`);
        }
      } else {
        setVerificationError("Verification failed. Please try again.");
      }
    } catch (error) {
      setVerificationError("An error occurred during verification");
    }
  };

  const handleResendCode = async () => {
    try {
      const url = `https://api.bestday2marry.com/email_verification/?user_id=${user_id}`;    
      const response = await fetch(url);
      const data = await response.json();
      
      if (data['status'] === 'success') {
        // Code was sent—start a new 60-second timer.
        setIsResendDisabled(true);
        setResendCountdown(60);
        setShowCodeSentMessage(true);
      } else if (data['remaining']) {
        // A code was recently sent so display the timer with the remaining seconds from the backend.
        setIsResendDisabled(true);
        setResendCountdown(data['remaining']);
        setShowCodeSentMessage(true);
      } else {
        setVerificationError(data['message'] || "Failed to resend verification code.");
      }
    } catch (error) {
      setVerificationError("An error occurred while resending the code");
    }
  };

  return (
    <div className="email-verification-body">
      <div className="email-verification-container">
        <div className="logo">BestDay2Marry</div>
        <div className="email-verification-form">
          <h1>Email Authentication</h1>
          <p>Please check your email for an authentication code. If not present, please check your spam.</p>
          <form onSubmit={handleVerify}>
            <div className="form-group">
              <input
                type="text"
                placeholder="Verification Code"
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
                className={verificationError ? 'error' : ''}
              />
              {verificationError && <div className="error-message">{verificationError}</div>}
            </div>
            <button type="submit" className="submit">Verify</button>
            <button type="button" className="tertiary-button" onClick={() => navigate(-1)}>Back</button>
          </form>
          <div className="alternative-verification">
            <button
              type="button"
              onClick={handleResendCode}
              disabled={isResendDisabled}
              className="resend-code-button"
            >
              Resend Verification Code
            </button>
            {showCodeSentMessage && isResendDisabled && (
              <div className="code-sent-message">
                A verification code has been sent! You can request another code in {resendCountdown} second{resendCountdown !== 1 ? 's' : ''}.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationPage;